import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DtoService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAll<T>(route: string): Observable<T[]> {
    return this.http.get<T[]>(this.baseUrl + 'api/' + route);
  }

  get<T>(route: string, primaryKey: string): Observable<T> {
    return this.http.get<T>(this.baseUrl + 'api/' + route + '/' + primaryKey);
  }

  create<T>(route: string, object: T): Observable<T> {
    return this.http.post<T>(this.baseUrl + 'api/' + route, object);
  }

  update<T>(route: string, object: T, primaryKey: string | number): Observable<T> {
    return this.http.put<T>(this.baseUrl + 'api/' + route + '/' + primaryKey, object);
  }

  delete<T>(route: string, primaryKey: string): Observable<T> {
    return this.http.delete<T>(this.baseUrl + 'api/' + route + '/' + primaryKey);
  }
}
